import * as angular from 'angular';

import { common } from '../common';

import { TagModel } from './tag.factory';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';

export const tagModel = angular.module('go.models.tag', [
	common,
	ngxFeatureFlagServiceModule
])
	.factory(TagModel.NG1_INJECTION_NAME, TagModel)
	.name;
